import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import {Input, Spin} from 'antd';
import { baseUrlLink } from "../../../../utils/types";
import axios from "axios";
import {belen_uri} from "../../../../utils/url";
import { toast } from "react-toastify";

export default function ProductLimit({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);

  const Call = () => {
    callback();
  }

  const Submit = async () => {
    setLoad(true);
    try{
        const res = await axios.patch(belen_uri+`/admin/product/limit`, {id: data.id});
        if(res.status === 200){
            toast.success("Амжилттай");
            onOpenChange(false);
            Call();
        }
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

  return (
    <>
      <Button size="sm" onPress={onOpen} className="text-black">Дууссан</Button>
      <Modal size="xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Барааг дууссан болгох</ModalHeader>
              <ModalBody>
                <div>
                  
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button color="primary">
                        <Spin/>
                    </Button>
                    :
                    <Button color="" onPress={Submit}>
                        Ok
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
